import React, { useState } from "react";
import { Box, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useViewSize from "../hooks/useViewSize";

export default function FileCard({
  file,
  onPreview,
  onDelete,
  viewSize = "small",
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { getStyleConfig } = useViewSize(viewSize);
  const styles = getStyleConfig();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePreview = () => {
    if (typeof onPreview === "function") {
      onPreview(file);
    }
    handleMenuClose();
  };

  const handleDelete = () => {
    if (typeof onDelete === "function") {
      onDelete(file);
    }
    handleMenuClose();
  };

  const isImage = file.fileName.match(/\.(jpeg|jpg|gif|png|bmp|webp|svg)$/i);

  if (viewSize === "small") {
    return (
      <Box sx={styles.container}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={styles.image.width}
          height={styles.image.height}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ ...styles.image, marginBottom: 0 }}
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>

        <Typography variant="body1" sx={styles.fileName} noWrap>
          {file.fileName}
        </Typography>
        <IconButton
          aria-label="more"
          aria-controls={open ? "file-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleMenuOpen}
          sx={styles.menuButton}
          size="small"
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="file-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
        ></Menu>
        <Menu /* ... */>
          <MenuItem onClick={handlePreview}>Preview</MenuItem>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
      </Box>
    );
  }

  // Render MEDIUM and LARGE view (vertical card)
  return (
    <Box sx={styles.container}>
      <Box sx={styles.topBar}>
        <Typography
          variant="body1"
          sx={styles.fileName}
          title={file.fileName}
          noWrap
        >
          {file.fileName}
        </Typography>
        <IconButton
          aria-label="more"
          aria-controls={open ? "file-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleMenuOpen}
          sx={styles.menuButton}
          size="small"
        >
          <MoreVertIcon />
        </IconButton>

        <Menu
          id="file-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handlePreview}>Preview</MenuItem>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
      </Box>
      {isImage && file.downloadURL ? (
        <img src={file.downloadURL} alt={file.fileName} style={styles.image} />
      ) : (
        <Box
          sx={{
            ...styles.image,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#555",
            fontSize: 32,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={styles.image.width}
            height={styles.image.height}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ ...styles.image, marginBottom: 0 }}
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </Box>
      )}
    </Box>
  );
}
